{
    "SectionheaderReportoptions": "Opzioni del rapporto",
    "ReporttablabelStyle": "Stile:",
    "ReporttablabelName": "Nome:",
    "ReporttablabelFolder": "Cartella:",
    "ReporttablabelNote": "Nota:",
    "ReporttabReportnameoverwritePromptTextFormatString": "Si è modificato lo stile di questo report - Si desidera sovrascrivere automaticamente il nome esistente del report con '|1'?",
    "NAME": "ReportOptions",
    "ReporttablabelInterval": "Intervallo:"
}